import React, { useEffect, useState, useLayoutEffect } from "react";
import { Search as SearchIcon } from 'react-feather';
import { useSearchBar } from '@magento/peregrine/lib/talons/SearchBar';
import Icon from '../Icon';
import TextInput from '../TextInput';
import { useIntl } from 'react-intl';
import { DEFAULT_SEARCH_UNIT_ID } from "@magento/peregrine/lib/talons/StorefrontLiveSearch/useStorefrontLiveSearch";
var SearchField = props => {
  var {
    outWrapperRef: inputRef
  } = props;
  var {
    formatMessage
  } = useIntl();
  var defaultSearch = null; //getSearchParam("query") || "";

  var [searchField, setSearchField] = useState(defaultSearch);
  var [searchHadChanged, setSearchHadChanged] = useState(false);
  var {
    handleSuggestion,
    validatedSearchValue,
    updateGtmEnteredInSearch,
    debouncedExecuteSearch
  } = useSearchBar();
  useEffect(() => {
    if (searchField !== null) {
      debouncedExecuteSearch(searchField);
      if (!searchHadChanged) {
        updateGtmEnteredInSearch();
        setSearchHadChanged(true);
      }
    }
  }, [searchField]);
  var focusSearchElement = e => {
    if (/^(?:input|textarea|select|button)$/i.test(e.target.tagName) || e.ctrlKey || e.metaKey) return;
    if (inputRef !== null && inputRef !== void 0 && inputRef.current && !inputRef.current.focused) {
      inputRef.current.focus();
    }
  };

  //page landing keyboard type will make use of search
  useLayoutEffect(() => {
    document.addEventListener('keypress', focusSearchElement);
    return () => {
      document.removeEventListener('keypress', focusSearchElement);
    };
  }, [window, document]);
  var searchIcon = /*#__PURE__*/React.createElement(Icon, {
    src: SearchIcon,
    size: 18,
    style: {
      backgroundColor: validatedSearchValue(searchField) ? '#DE0107' : 'var(--color-lightgray)',
      borderTopRightRadius: '3.125rem',
      borderBottomRightRadius: '3.125rem',
      width: '100%',
      height: '100%',
      color: 'white',
      marginRight: '-0.25rem',
      transition: '300ms'
    }
  });
  var onSearch = () => {
    handleSuggestion(searchField);
    setSearchHadChanged(false);
    setSearchField("");
  };
  return /*#__PURE__*/React.createElement(TextInput, {
    before: null,
    after: searchIcon,
    field: DEFAULT_SEARCH_UNIT_ID,
    id: DEFAULT_SEARCH_UNIT_ID,
    onChange: e => setSearchField(e.target.value),
    defaultValue: searchField,
    currentRef: inputRef,
    type: "search",
    onSearch: onSearch,
    onKeyPress: e => {
      if (e.key === 'Enter') {
        onSearch();
      }
    },
    placeholder: formatMessage({
      id: 'searchBar.placeHolder',
      defaultMessage: 'What are you looking for?'
    })
  });
};
export default SearchField;